export enum ModulePaymentTypeEnum {
  OneTime,
  Recurring
}

export enum ModuleAccessoryTypeEnum {
  Legacy,
  Configurable
}
